import { get } from 'lodash'
import Vue from 'vue'
import { invoicePrintStatusConfig } from '@/config/invoiceRecord'

let linkedWarningMessageHandle = null

export const showInvoiceLinkedWarning = async ({ messageBefore, linkText, messageAfter, onClick }) => {
  if (linkedWarningMessageHandle?.close) {
    linkedWarningMessageHandle.close()
  }

  await new Vue().$nextTick()
  const h = new Vue().$createElement
  setTimeout(() => {
    linkedWarningMessageHandle = window.$message.warning({
      message: h('span', { class: 'el-message__content' }, [
        messageBefore,
        h('span', {
          class: 'text-primary-100 underline cursor-pointer',
          on: {
            click: () => {
              onClick()
              linkedWarningMessageHandle.close()
            },
          },
        }, linkText),
        messageAfter,
      ]),
      duration: 0,
      showClose: true,
    })
  }, 0)
}

const pushInvoiceDetail = ({ record, router }) => {
  router.push({
    name: 'InvoiceRecords',
    query: {
      invoiceNo: get(record, 'invoiceNo'),
      sourceType: get(record, 'sourceType'),
      view: 'detail',
    },
  })
}

export const showInvoiceIssuedToast = (record) => {
  if (!record) return
  window.$message.success({
    message: `發票已開立，第三方平台已回傳 ${get(record, 'invoiceNo') || '-'}。`,
  })
}

export const showInvoicePrintResultToast = ({ record, router } = {}) => {
  const printStatus = get(record, 'printStatus')
  if (printStatus === invoicePrintStatusConfig.printFailed.value) {
    if (!get(record, 'id') || !router) {
      window.$message.warning({
        message: '發票已開立但列印失敗，請至發票紀錄詳情補印',
      })
      return
    }

    showInvoiceLinkedWarning({
      messageBefore: '發票已開立但列印失敗。前往 ',
      linkText: '發票紀錄詳情',
      messageAfter: ' 補印',
      onClick: () => pushInvoiceDetail({ record, router }),
    })
    return
  }

  if (printStatus === invoicePrintStatusConfig.printed.value) {
    window.$message.success({
      message: '發票列印成功。',
    })
  }
}

export const showInvoicePrintTimeoutToast = ({ record, router } = {}) => {
  if (!get(record, 'id') || !router) {
    window.$message.warning({
      message: '發票已成立，但門市發票機連線逾時。請至發票紀錄詳情補印',
    })
    return
  }

  showInvoiceLinkedWarning({
    messageBefore: '發票已成立，但門市發票機連線逾時。前往 ',
    linkText: '發票紀錄詳情',
    messageAfter: ' 補印',
    onClick: () => pushInvoiceDetail({ record, router }),
  })
}
